export enum RouteBenutzerprofilMenuGroup {
	AUFGABEN = "Aufgaben",
	EINSTELLUNGEN = "Einstellungen"
}
